import React from 'react';
import { formatCurrency, formatDate } from '../../../../../utils/format';
import { MODO_IMPRESSAO } from '~/constants';

const ParcelasTable = ({ parcelas, modoImpressao }) => {
  const parcelasOrdenadas = [...(parcelas || [])].sort((a, b) => {
    if (a.parcelaNumero == null) return 1;
    if (b.parcelaNumero == null) return -1;
    return a.parcelaNumero - b.parcelaNumero;
  });
  const middleIndex = Math.ceil((parcelasOrdenadas?.length || 0) / 2);
  const primeiraTabela = parcelasOrdenadas?.slice(0, middleIndex);
  const segundaTabela = parcelasOrdenadas?.slice(middleIndex);
  const impressaoA4 = modoImpressao === MODO_IMPRESSAO.A4;
  return (
    <div className='scrollable' style={{ border: '1px solid black', padding: 'var(--spacing-size)', borderBottom: 'none', overflowX: 'auto' }}>
      <div style={{ fontWeight: '700', fontSize: 'var(--section-title-text-size)', paddingBottom: 'var(--half-spacing-size)' }}>
        PAGAMENTO
      </div>
      {impressaoA4 ? (
        <ParcelasFullTable parcelas={parcelasOrdenadas} />
      ) : (
        (parcelasOrdenadas?.length <= 1) ? (
          <ParcelasSubTable
              parcelas={parcelasOrdenadas}
          />
        ) : (
          <div
            style={{
              display: 'flex',
              width: '100%',
              justifyContent: 'space-between',
            }}
          >
            <div>
              <ParcelasSubTable
                parcelas={primeiraTabela}
              />
            </div>

            <div style={{ borderLeft: '1px dashed black', margin: `var(--spacing-size) var(--half-spacing-size)` }} />

            <div>
              <ParcelasSubTable
                parcelas={segundaTabela}
                startIndex={middleIndex}
              />
            </div>
          </div>
        )
      )}
    </div>
  );
};

export default ParcelasTable;

const ParcelasFullTable = ({ parcelas }) => {
    return (
      <table style={{ width: '100%' }}>
        <thead style={{ fontSize: 'var(--regular-text-size)', fontWeight: 700, paddingBottom: 'var(--half-spacing-size)' }}>
          <tr>
            <th style={{ verticalAlign: 'top', textAlign: 'left', whiteSpace: 'nowrap', paddingLeft: '0px', paddingRight: 'calc(var(--horizontal-item-grid-spacing)/2)', paddingTop: `calc(var(--vertical-item-grid-spacing)/2)`, paddingBottom: `calc(var(--vertical-item-grid-spacing)/2)` }}>Parcela</th>
            <th style={{ verticalAlign: 'top', textAlign: 'left', whiteSpace: 'normal', wordBreak: 'break-word', overflowWrap: 'anywhere', minWidth: '60px', padding: `calc(var(--vertical-item-grid-spacing)/2) calc(var(--horizontal-item-grid-spacing)/2)` }}>Meio de Pagemento</th>
            <th style={{ verticalAlign: 'top', textAlign: 'left', whiteSpace: 'nowrap', padding: `calc(var(--vertical-item-grid-spacing)/2) calc(var(--horizontal-item-grid-spacing)/2)` }}>Vencimento</th>
            <th style={{ verticalAlign: 'top', textAlign: 'left', whiteSpace: 'nowrap', padding: `calc(var(--vertical-item-grid-spacing)/2) calc(var(--horizontal-item-grid-spacing)/2)` }}>Valor</th>
            <th style={{ verticalAlign: 'top', textAlign: 'left', whiteSpace: 'nowrap', padding: `calc(var(--vertical-item-grid-spacing)/2) calc(var(--horizontal-item-grid-spacing)/2)` }}>Valor Juros</th>
            <th style={{ verticalAlign: 'top', textAlign: 'left', whiteSpace: 'nowrap', padding: `calc(var(--vertical-item-grid-spacing)/2) calc(var(--horizontal-item-grid-spacing)/2)` }}>Valor Total</th>
            <th style={{ verticalAlign: 'top', textAlign: 'left', whiteSpace: 'nowrap', paddingLeft: 'calc(var(--horizontal-item-grid-spacing)/2)', paddingRight: '0px', paddingTop: `calc(var(--vertical-item-grid-spacing)/2)`, paddingBottom: `calc(var(--vertical-item-grid-spacing)/2)` }}>Qtd. Parcelas</th>
          </tr>
        </thead>

        <tbody>
          {parcelas?.map((item, index) => (
            <tr style={{ fontSize: 'var(--regular-text-size)', textAlign: 'left' }} key={item?.id || index}>
              <td style={{ verticalAlign: 'top', textAlign: 'left', whiteSpace: 'nowrap', paddingLeft: '0px', paddingRight: 'calc(var(--horizontal-item-grid-spacing)/2)', paddingTop: `calc(var(--vertical-item-grid-spacing)/2)`, paddingBottom: `calc(var(--vertical-item-grid-spacing)/2)` }}>{item?.parcelaNumero}</td>
              <td style={{ verticalAlign: 'top', textAlign: 'left', whiteSpace: 'normal', wordBreak: 'break-word', overflowWrap: 'anywhere', minWidth: '60px', padding: `calc(var(--vertical-item-grid-spacing)/2) calc(var(--horizontal-item-grid-spacing)/2)` }}>{item?.finMeiopagamento?.descricao}</td>
              <td style={{ verticalAlign: 'top', textAlign: 'left', whiteSpace: 'nowrap', padding: `calc(var(--vertical-item-grid-spacing)/2) calc(var(--horizontal-item-grid-spacing)/2)` }}>{formatDate(new Date(item?.parcelaVencimento))}</td>
              <td style={{ verticalAlign: 'top', textAlign: 'left', whiteSpace: 'nowrap', padding: `calc(var(--vertical-item-grid-spacing)/2) calc(var(--horizontal-item-grid-spacing)/2)` }}>{formatCurrency(item?.parcelaValor)}</td>
              <td style={{ verticalAlign: 'top', textAlign: 'left', whiteSpace: 'nowrap', padding: `calc(var(--vertical-item-grid-spacing)/2) calc(var(--horizontal-item-grid-spacing)/2)` }}>{formatCurrency(item?.parcelaValorJuros)}</td>
              <td style={{ verticalAlign: 'top', textAlign: 'left', whiteSpace: 'nowrap', padding: `calc(var(--vertical-item-grid-spacing)/2) calc(var(--horizontal-item-grid-spacing)/2)` }}>{formatCurrency(item?.parcelaValorTotal)}</td>
              <td style={{ verticalAlign: 'top', textAlign: 'left', whiteSpace: 'nowrap', paddingLeft: 'calc(var(--horizontal-item-grid-spacing)/2)', paddingRight: '0px', paddingTop: `calc(var(--vertical-item-grid-spacing)/2)`, paddingBottom: `calc(var(--vertical-item-grid-spacing)/2)` }}>{item?.parcelaQuantidade}</td>
            </tr>
          ))}
        </tbody>
      </table>
    );
}

const ParcelasSubTable = ({ parcelas, startIndex = 0 }) => {
    return (
      <table style={{ width: '100%' }}>
        <thead style={{ fontSize: 'var(--regular-text-size)', fontWeight: 700, paddingBottom: 'var(--half-spacing-size)' }}>
          <tr>
            <th style={{ verticalAlign: 'top', textAlign: 'left', whiteSpace: 'nowrap', paddingLeft: '0px', paddingRight: 'calc(var(--horizontal-item-grid-spacing)/2)', paddingTop: `calc(var(--vertical-item-grid-spacing)/2)`, paddingBottom: `calc(var(--vertical-item-grid-spacing)/2)` }}>Parc.</th>
            <th style={{ verticalAlign: 'top', textAlign: 'left', whiteSpace: 'normal', wordBreak: 'break-word', overflowWrap: 'anywhere', minWidth: '60px', padding: `calc(var(--vertical-item-grid-spacing)/2) calc(var(--horizontal-item-grid-spacing)/2)` }}>M. Pagto.</th>
            <th style={{ verticalAlign: 'top', textAlign: 'left', whiteSpace: 'nowrap', padding: `calc(var(--vertical-item-grid-spacing)/2) calc(var(--horizontal-item-grid-spacing)/2)` }}>Vencimento</th>
            <th style={{ verticalAlign: 'top', textAlign: 'left', whiteSpace: 'nowrap', padding: `calc(var(--vertical-item-grid-spacing)/2) calc(var(--horizontal-item-grid-spacing)/2)` }}>Val. Total</th>
            <th style={{ verticalAlign: 'top', textAlign: 'left', whiteSpace: 'nowrap', paddingLeft: 'calc(var(--horizontal-item-grid-spacing)/2)', paddingRight: '0px', paddingTop: `calc(var(--vertical-item-grid-spacing)/2)`, paddingBottom: `calc(var(--vertical-item-grid-spacing)/2)` }}>Qtd. Parc.</th>
          </tr>
        </thead>

        <tbody>
          {parcelas?.map((item, index) => (
            <tr style={{ fontSize: 'var(--regular-text-size)', textAlign: 'left' }} key={item?.id || (index + startIndex)}>
              <td style={{ verticalAlign: 'top', textAlign: 'left', whiteSpace: 'nowrap', paddingLeft: '0px', paddingRight: 'calc(var(--horizontal-item-grid-spacing)/2)', paddingTop: `calc(var(--vertical-item-grid-spacing)/2)`, paddingBottom: `calc(var(--vertical-item-grid-spacing)/2)` }}>{item?.parcelaNumero}</td>
              <td style={{ verticalAlign: 'top', textAlign: 'left', whiteSpace: 'normal', wordBreak: 'break-word', overflowWrap: 'anywhere', minWidth: '60px', padding: `calc(var(--vertical-item-grid-spacing)/2) calc(var(--horizontal-item-grid-spacing)/2)` }}>{item?.finMeiopagamento?.descricao}</td>
              <td style={{ verticalAlign: 'top', textAlign: 'left', whiteSpace: 'nowrap', padding: `calc(var(--vertical-item-grid-spacing)/2) calc(var(--horizontal-item-grid-spacing)/2)` }}>{formatDate(new Date(item?.parcelaVencimento))}</td>
              <td style={{ verticalAlign: 'top', textAlign: 'left', whiteSpace: 'nowrap', padding: `calc(var(--vertical-item-grid-spacing)/2) calc(var(--horizontal-item-grid-spacing)/2)` }}>{formatCurrency(item?.parcelaValorTotal)}</td>
              <td style={{ verticalAlign: 'top', textAlign: 'left', whiteSpace: 'nowrap', paddingLeft: 'calc(var(--horizontal-item-grid-spacing)/2)', paddingRight: '0px', paddingTop: `calc(var(--vertical-item-grid-spacing)/2)`, paddingBottom: `calc(var(--vertical-item-grid-spacing)/2)` }}>{item?.parcelaQuantidade}</td>
            </tr>
          ))}
        </tbody>
      </table>
    );
};
